export const ErrorMessages = {
  AddSuccess: '',
  AddFailure: '',
  LoadSuccess: '',
  LoadFailure: '',
  RemoveSuccess: '',
  RemoveFailure: '',
  ModifySuccess: '',
  ModifyFailure: '',
  ArchiveSuccess: '',
  ArchiveFailure: '',
}
export type ErrorMessageTypes =
    'AddSuccess' |
    'AddFailure' |
    'LoadSuccess' |
    'LoadFailure' |
    'RemoveSuccess' |
    'RemoveFailure' |
    'ModifySuccess' |
    'ModifyFailure' |
    'UploadFailure' |
    'UploadSuccess' |
    'DownloadFailure' |
    'DownloadSuccess' |
    'ArchiveSuccess' |
    'ArchiveFailure' |
    'UnArchiveSuccess' |
    'UnArchiveFailure' |
    'GenerateSuccess' |
    'GenerateFailure'

export function GetMessage(type: ErrorMessageTypes, name: string){
  const typeMap = {
    AddSuccess: `Added ${name}`,
    AddFailure: `Failed to Add ${name}`,
    LoadSuccess: `Loaded ${name}`,
    LoadFailure: `Failed to Load ${name}`,
    RemoveSuccess: `Removed ${name}`,
    RemoveFailure: `Failed to Remove ${name}`,
    ModifySuccess: `Updated ${name}`,
    ModifyFailure: `Failed to Update ${name}`,
    UploadFailure: `Failed to Upload ${name}`,
    UploadSuccess: `Uploaded ${name}`,
    DownloadFailure: `Failed to Download ${name}`,
    DownloadSuccess: `Downloaded ${name}`,
    ArchiveSuccess: `Archived ${name}`,
    ArchiveFailure: `Failed to Archive ${name}`,
    UnArchiveSuccess: `Restored ${name}`,
    UnArchiveFailure: `Failed to Restore ${name}`,
    GenerateSuccess: `Generated ${name}`,
    GenerateFailure: `Failed to Generate ${name}`,
  }
  return typeMap[type];
}


